// eslint-disable-next-line no-unused-vars
let confettiFn: ((opts: Record<string, unknown>) => void) | null = null;

export function reducedMotion() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export async function burst(opts: { spread?: number; count?: number; mint?: boolean } = {}) {
  if (typeof window === "undefined" || reducedMotion()) return;
  if (!confettiFn) {
    const mod = await import("canvas-confetti");
    // eslint-disable-next-line no-unused-vars
    confettiFn = mod.default as unknown as (o: Record<string, unknown>) => void;
  }
  confettiFn({
    particleCount: opts.count ?? 60,
    spread: opts.spread ?? 70,
    origin: { y: 0.55 },
    scalar: 0.9,
    ticks: 160,
    colors: opts.mint ? ["#5EEAD4", "#F5D06B", "#ffffff"] : ["#F5D06B", "#E7B62A", "#ffffff"],
  });
}

export function buzz(pattern: number | number[] = 10) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(pattern);
  } catch {
    /* ignore */
  }
}
